import axios from 'axios';
import { headers, baseUrl, extendHeaders } from "./HelpService";
import { UploadResponse } from '../../types/Document.type';


const PageUrl = baseUrl + 'document/';

const uploadDocument = (type, accountId, file, shipmentId = null, removalOrderId = null): Promise<UploadResponse | null> => {
    let formData = new FormData();
    formData.append("type", type);
    formData.append("account_id", accountId);
    if (file instanceof FileList || Array.isArray(file)) {
        Array.from(file).forEach(file => {
            formData.append("file", file);
        });
    } else {
        formData.append("file", file);
    }
    if (shipmentId)
        formData.append("inbound_shipment_id", shipmentId);
    if (removalOrderId)
        formData.append("removal_order_id", removalOrderId);
    return fetch(PageUrl + "uploadDocument/", {
        method: "PUT",
        headers: headers(),
        body: formData
    })
        .then((response) => response.json())
        .then((data) => data as UploadResponse)
        .catch(error => {
            return null;
        });
};

const downloadDocument = (accountId, fileId, fileName) => {

    return fetch(PageUrl + `downloadDocument/?account_id=${accountId}&file_id=${fileId}`, {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });

    // axios({
    //     url: PageUrl + `downloadDocument/?account_id=${accountId}&file_id=${fileId}`,
    //     method: 'GET',
    //     headers: headers()
    // }).then((response) => {
    //     var a = document.createElement("a");
    //     a.href = "data:application/pdf;base64," + response.data;
    //     a.download = fileName;
    //     a.click();
    // });
};

const downloadDocuments = (accountId, type, shipmentId, removalOrderId) => {
    const queryParams = new URLSearchParams();
    queryParams.set('account_id', accountId);
    queryParams.set('type', type);
    if (shipmentId && shipmentId !== undefined) {
        queryParams.set('inbound_shipment_id', shipmentId);
    }
    if (removalOrderId && removalOrderId !== undefined) {
        queryParams.set('removal_order_id', removalOrderId);
    }
    const search = queryParams.toString();

    return fetch(PageUrl + `downloadDocuments/?${search}`,
        {
            method: "GET",
            headers: headers()
        }
    ).then((response) => response.blob())
        .catch(error => { return null; });

};
const getDocuments = (accountId, type, inbound_shipment_id = null): Promise<Response | null> => {
    var params = { account_id: accountId, type: type };
    if (inbound_shipment_id) {
        params['inbound_shipment_id'] = inbound_shipment_id;
    }
    return fetch(PageUrl + '?' + new URLSearchParams(params).toString()
        , {
            method: "GET",
            headers: headers()
        })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};


const DocumentService = {
    uploadDocument,
    downloadDocument,
    getDocuments,
    downloadDocuments,
};

export default DocumentService;
